module.exports = __webpack_public_path__ + "static/media/om_beard_stubble_round_grey.d8eb58f0.png";